export default class Instructor {
    static fromData(data) {
        if (!data) {
            return;
        }

        let instructor = new Instructor();

        instructor.id = data.id || null;
        instructor.fullName = data.fullName;

        Object.seal(instructor);
        return instructor;
    }

    equals(instructor){
        if (instructor.id === null) {
            return false;
        }
        return instructor.id === this.id;
    }
}
